import styled from "styled-components";
import { ServiceBg, } from "../../Styled/AllImages";


export const ServiceWrapper = styled.section`
    position:relative;
    
.product-wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 2px solid var(--darkColor);
    border-radius: 10px;
    width: 40%;
    margin: 15px 0;
}
.product-wrapper-tabs{
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text);
    width: 100%;
    transition: transform 0.4s ease-in-out;
    &>span{
        padding:10px 6px;
        width: 100%;
        text-align:center;
        border-radius:8px;
        transition: all 0.4s ease-in-out;
    }
    &>span:hover, & .activeTab{
        background-color: var(--darkColor);
        color: var(--white);
    } 
}
.tab-active-row{
    row-gap:25px;
}
.active-tab-content{
    position:relative;
    height: 210px;
    border-radius: 12px;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: cover !important;
   
    &::before{
        content:"";
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:210px;
        background-image: url(${ServiceBg});
        border-radius: 12px;
        background-size: 100% 100%;
    }
 }

 .service-text {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 100%;
    z-index: 1;
    position: relative;
    padding: 0 8px 20px;
    text-align: center;
}

.Operations-box{

    &>div{
         position:relative;
         height: 100%;
         border-radius: 12px;
         background-repeat: no-repeat !important;
        background-position: center !important;
         background-size: cover !important;
           
         &::before{
            content:"";
            position:absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            background-image: url(${ServiceBg});
            border-radius: 12px;
            background-size: 100% 100%;
        }
    }

    & .service-bg{
        height: 100%;
        border-radius: 12px;
        background-position: center !important;
        background-size: cover!important;
        background-repeat: no-repeat !important;
    }
}

.Operations-container{
    display: grid;
    gap:15px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
}
.item-1 {
    grid-column: 1 / 1;
    grid-row: 1 / 3;
    height:430px;
}
.item-4{
    grid-column: 4 / 4;
    grid-row: 1 /3;
    height:430px;
}
.item-5{
    grid-column: 2 / 4;
    grid-row: 2 /3;
    border-radius: 12px;
}


`